<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/mail-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">{{data.mode === 'edit' ? "Modificar correo" : "Enviar correo"}}</h4><h6 class="color-gray" style="font-weight: 400;">{{data.mode === 'edit' ? "Completa los datos que necesitas modificar del correo" : "Completa la información para enviar un nuevo correo."}}</h6></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            @if(outlook_mail && outlook_connected){
            <div class="main-mailing">
                <div class="mt-5">
                    <h6 class="">Información del correo</h6>
                </div>

                <div class="mail-form">
                    <div class="d-grid mail-input mt-3">
                        <div>
                            <label class="login-label" for=""><p class="color-org d-inline">*</p> De:</label>
                        </div>
                        <div>
                            <input class="crm-input" type="email" name="to" id="to" [value]="outlook_mail" disabled>
                        </div>
                        <div>
                            <label class="login-label" for=""><p class="color-org d-inline">*</p> Para:</label>
                        </div>
                        <div>
                            <input class="crm-input" type="email" name="to" id="to" [(ngModel)]="request.to" placeholder="destinatario@empresa.com">
                        </div>
                    </div>
                    <hr class="mt-2">
                    <div class="d-grid mail-input mt-3">
                        <div>
                            <label class="login-label" for=""><p class="color-org d-inline">*</p> Asunto:</label>
                        </div>
                        <div>
                            <input class="crm-input" type="text" name="subject" id="subject" [(ngModel)]="request.subject">
                        </div>
                    </div>
                    <hr class="mt-2">
                </div>

                <div class="mt-3" style="display: flex; justify-content: left;">
                    <quill-editor 
                    [(ngModel)]="request.body"
                    [modules]="quillConfig"
                    [styles]="{height: '150px', width: '700px'}"
                    placeholder="Estimado cliente,&#10;&#10;Escribe tu mensaje aquí...&#10;&#10;Saludos cordiales"
                    (onContentChanged)="onContentChanged($event)"
                    (onEditorCreated)="onEditorCreated($event)">
                    </quill-editor>
                </div>

                <div class="d-flex flex-row justify-center gap-20 mt-2">
                    <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                    @if(data.mode === 'edit'){
                        <button class="btn btn-primary text-center" (click)="sendMail()">Modificar correo</button>
                    }@else{
                        <button class="btn btn-primary text-center" (click)="sendMail()">Enviar correo</button>
                    }
                </div>
            </div>
        }@else{
            <div class="no-outlook-connection">
                <h5 class="text-center mt-3">No hay una cuenta de Outlook conectada</h5>
                <p class="text-center color-gray">Para enviar correos electrónicos desde esta aplicación, es necesario conectar una cuenta de Outlook.</p>
                <div class="d-flex flex-row justify-center mt-4">
                    <button class="btn btn-primary" (click)="connectOutlook()">Conectar cuenta de Outlook</button>
                </div>
            </div>
        }
        </div>
    </div>
</div>
